export default "__VITE_ASSET__IB5hUAub__"